module.exports = __webpack_public_path__ + "img/image_01.0c4f9824.png";